export function ProductName() {
  return (
    <a
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: '#3F79A4',
        textDecoration: 'none',
      }}
      href={window.location.pathname === '/' ? '#' : '/'}
    >
      <img
        src={'/logo.png'}
        alt="logo"
        style={{ marginRight: 8 }}
        height="30"
      />
      <h3 style={{ margin: 0 }}>SuperWallet</h3>
    </a>
  );

}